import React from "react";
import { useNavigate } from "react-router-dom";
// import { Post } from "../core/lib/types";               
import '../App.css';
// import {  formatTimeAMPM } from '../core/lib/utils';
import { getVideoThumb } from "../core/lib/utils";

function ProfilePostComponent({ id, user, media, caption, vendor,
  location, thumbnail, createdAt, meta, user_action, posts, profile, likedBy, likes, pinnedBy, total }: any) {
    // navigate to Login
    const navigate = useNavigate();

    const routeTo = (post: any) => {
        //
        navigate('/post-view', { state: {post: post, posts: posts} })
      }
    //
    return (
              <div onClick={e=>routeTo({
                id,
                user,
                caption,
                media,
                vendor,
                location,
                thumbnail,
                createdAt,
                meta,
                user_action,
                posts,
                profile,
                likedBy,
                likes,
                pinnedBy,
                total
            })} key={id}>
                <div className='flex flex-col'>

                            { typeof(media) !== "undefined" && media.type  === 'image' ?
                              <img style={{ objectFit: 'cover'}} className="relative aspect-square h-auto max-w-full rounded-xl" src={media.url+'#t=0.001'} alt=""/>
                              : typeof(media) !== "undefined" && media.type === 'video' ?
                              <video poster={getVideoThumb(media.url)} style={{ objectFit: 'cover'}} className="relative aspect-square h-auto max-w-full rounded-xl" >
                                <source src={media.url+'#t=0.001'}></source>
                                </video>
                              : ''
                            }
                            <div className="flex flex-col text-left pt-3 pb-2 pl-2">
                              <p className="text-sm ">{caption}</p>
                              {/* <span className="text-xs text-slate-600 pt-2.5 text-yellow-800">
                              { new Date(date).toDateString().substring(4)} • { formatTimeAMPM(date) }
                              </span>
                              <span className="text-xs font-light text-gray-400">{location?.name}</span> */}
                              
                              
                    </div>

                </div> 
        </div>             

   

    )
}

export default ProfilePostComponent